const state = () => {
    return {
        cruiseTypes: [],
    };
};

// getters
const getters = {
    getCruiseTypes: (state) => state.cruiseTypes,
};

// actions
const actions = {
    dispatchCruiseTypes({ commit }, payload) {
        commit('setCruiseTypes', payload);
    },
};

// mutations
const mutations = {
    setCruiseTypes(state, payload) {
        state.cruiseTypes = payload;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
